const ttqEvents = {
    completeRegistration: () =>
        (window as any)?.ttq?.track?.('CompleteRegistration'),
    subscribe: () => (window as any)?.ttq?.track?.('Subscribe'),
};

export default ttqEvents;
